<h2 class="title">{{ '+VOUCHERS.VALIDATE_VOUCHER' | translate }}</h2>
<vi-text class="description">{{ '+VOUCHERS.VALIDATE_VOUCHER_DESCRIPTION' | translate }}</vi-text>
<div class="grid">
  <!-- VOUCHER CODE INPUT-->
  <mat-form-field mat-input-height-large-label class="voucher-input">
    <mat-label>{{ '+VOUCHERS.VOUCHER_CODE' | translate }}</mat-label>
    <input
      matInput
      (keyup)="checkForEmptyInput()"
      [errorStateMatcher]="matcher"
      [formControl]="formGroup.controls.voucher"
      fieldTextContentTooltip
    />
  </mat-form-field>

  <!-- VALIDATE BTN -->
  <button
    disabled
    gtm="onSelect"
    gtmAction="Validate Voucher"
    gtmCategory="voucher"
    mat-raised-button
    color="primary"
    (click)="validateVoucher()"
    [disabled]="!formGroup.valid || (vouchersStore.isValidatingVoucher$ | async)"
  >
    <ng-container *ngIf="!(vouchersStore.isValidatingVoucher$ | async); else loading">{{
      '+VOUCHERS.VALIDATE_BTN' | translate
    }}</ng-container>
    <ng-template #loading><mat-icon class="spin">autorenew</mat-icon></ng-template>
  </button>
</div>

<ng-container *ngIf="vouchersStore.getAttemptedToValidateVoucher$ | async">
  <ng-container *ngIf="vouchersStore.voucherValidatedSuccesfully$ | async; else serverError">
    <ng-container *ngIf="vouchersStore.isVoucherAvailable$ | async; else voucherNotAvailable">
      <app-voucher-result-box [success]="true">
        <span content>{{ '+VOUCHERS.VALIDATE_SUCCESS_AVAILABLE' | translate }}</span>
      </app-voucher-result-box>
    </ng-container>
  </ng-container>

  <ng-template #voucherNotAvailable>
    <app-voucher-result-box [success]="false">
      <span content>{{ '+VOUCHERS.VALIDATE_SUCCESS_NOT_AVAILABLE' | translate }}</span>
    </app-voucher-result-box>
  </ng-template>

  <ng-template #serverError>
    <app-voucher-result-box [success]="false">
      <span content>{{ '+VOUCHERS.SERVER_ERROR' | translate }}</span>
    </app-voucher-result-box>
  </ng-template>
</ng-container>
